import { callBridgeViaParent, useIframeBridge } from '@/hooks/useIframeBridge'
import { invoke } from '@kiti/js-bridge'

import type {
  HistoryResponse,
  HistoryRewardRecord,
  InviteeResponse,
  RecruitType,
  TodayCoinListResponse
} from './recruit-type'

export async function getRecruitBaseInfo() {
  return invoke<ApiResponse<RecruitType>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/baseInfo'
  })
}

export async function getClaimReward() {
  return invoke<ApiResponse<RecruitType>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/claimReward'
  })
}

export async function historyRewardRecordList(params: {
  pageNo: number
  pageSize: number
  filterType?: string
}) {
  return invoke<ApiResponse<HistoryRewardRecord>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/historyRewardRecordList',
    params: {
      ...params
    }
  })
}

export async function getInviteeFirst(params: { pageNo: number; pageSize: number }) {
  return invoke<ApiResponse<InviteeResponse>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/earnMethodOne',
    params: {
      ...params
    }
  })
}

export async function getInviteeSecond(params: { pageNo: number; pageSize: number }) {
  return invoke<ApiResponse<InviteeResponse>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/earnMethodTwo',
    params: {
      ...params
    }
  })
}

export async function getDayCoinList(params: {
  queryDate?: string
  queryUid?: string
  pageNo: number
  pageSize: number
}) {
  return invoke<ApiResponse<TodayCoinListResponse>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/todayCoinList',
    params: {
      ...params
    }
  })
}

export async function getHistoryCoinList(params: { pageNo: number; pageSize: number }) {
  return invoke<ApiResponse<HistoryResponse>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/earnMethodTwoHistoryList',
    params: {
      ...params
    }
  })
}

export async function getHistoryCoinListInRewardDetail() {
  return invoke<ApiResponse<TodayCoinListResponse>>('request', {
    path: '/kiti-chat/outer/anchor/historyCoinList'
  })
}

export async function getTodayRewardSummary() {
  // 增加 iframe 调用
  const { isInIframe } = useIframeBridge()

  if (isInIframe) {
    const resp = await callBridgeViaParent('request', {
      path: 'kiti-chat/kiti-activities/api/auth/invite/todayRewardSummary'
    })

    if (typeof resp === 'object' && resp?.data) {
      const res = resp.data as ApiResponse<RecruitType>

      if (res.resultCode !== 1) {
        return Promise.reject(res)
      }
      return res.result
    }
    return resp
  }

  return invoke<ApiResponse<RecruitType>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/todayRewardSummary'
  })
}

export async function confirmFirstRewardTips() {
  return invoke<ApiResponse<RecruitType>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/invite/confirmFirstRewardTips'
  })
}

export async function getRushSummary() {
  // 增加 iframe 调用
  const { isInIframe } = useIframeBridge()

  if (isInIframe) {
    const resp = await callBridgeViaParent('request', {
      path: 'kiti-chat/kiti-activities/api/auth/goldRush/summary'
    })

    if (typeof resp === 'object' && resp?.data) {
      const res = resp.data as ApiResponse<RecruitType>

      if (res.resultCode !== 1) {
        return Promise.reject(res)
      }
      return res.result
    }
    return resp
  }

  return invoke<ApiResponse<RecruitType>>('request', {
    path: '/kiti-chat/kiti-activities/api/auth/goldRush/summary'
  })
}

/** 是否为 Ru 签约主播 */
export async function isRuContractedAnchor() {
  return invoke<ApiResponse<boolean>>('getRequest', {
    path: '/kiti-chat/kiti-activities/api/auth/anchorInviteUser/hasAnchorInviteUserPermission'
  })
}
